import React, { useState, useCallback } from 'react';
import { Typography } from '@mui/material/';

const SearchSuggestions = ({
    suggestions,
    selectedIndex,
    onSuggestionClick,
    stockDataMap
}) => {
    const [hoveredIndex, setHoveredIndex] = useState(-1);
    const [imageErrors, setImageErrors] = useState(new Set());

    // ฟังก์ชันสร้างสีจาก symbol
    const getColorFromSymbol = useCallback((symbol) => {
        const colors = [
            '#3b82f6', // blue
            '#22c55e', // green
            '#a855f7', // purple
            '#f97316', // orange
            '#ec4899', // pink
            '#6366f1', // indigo
            '#14b8a6', // teal
            '#f59e0b', // amber
        ];
        const index = symbol.charCodeAt(0) % colors.length;
        return colors[index];
    }, []);

    const getStockIcon = useCallback((symbol) => {
        if (stockDataMap && stockDataMap.has(symbol)) {
            const stockData = stockDataMap.get(symbol);

            // ถ้ามี logo_url และยังไม่ error
            if (stockData.logo_url && !imageErrors.has(symbol)) {
                return (
                    <img
                        src={stockData.logo_url}
                        alt={symbol}
                        className="w-full h-full object-cover"
                        onError={() => {
                            setImageErrors(prev => new Set([...prev, symbol]));
                        }}
                        loading="lazy"
                        style={{
                            display: 'block',
                            borderRadius: '50%'
                        }}
                    />
                );
            }
        }

        // Fallback: แสดง avatar สวยๆ
        const bgColor = getColorFromSymbol(symbol);
        const letter = symbol.charAt(0).toUpperCase();

        return (
            <div
                className="w-full h-full flex items-center justify-center"
                style={{
                    backgroundColor: bgColor,
                    borderRadius: '50%'
                }}
            >
                <span className="text-white font-bold text-base">
                    {letter}
                </span>
            </div>
        );
    }, [stockDataMap, imageErrors, getColorFromSymbol]);

    if (!suggestions || suggestions.length === 0) return null;

    return (
        <div
            className="absolute top-full left-0 mt-2 bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-200"
            style={{
                width: '400px',
                zIndex: 9999
            }}
        >
            <div className="max-h-500px overflow-y-auto">
                {suggestions.map((stock, index) => {
                    const isSelected = index === selectedIndex;
                    const isHovered = index === hoveredIndex;
                    const isActive = isSelected || isHovered;

                    return (
                        <button
                            key={stock.symbol}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                onSuggestionClick(stock.symbol);
                            }}
                            onMouseEnter={() => setHoveredIndex(index)}
                            onMouseLeave={() => setHoveredIndex(-1)}
                            className={`w-full px-5 py-4 transition-all duration-150 flex items-center gap-4 border-b border-gray-100 last-border-b-0 ${isActive
                                ? 'bg-blue-100 border-l-4 border-l-blue-500'
                                : 'hover-bg-gray-50 border-l-4 border-l-transparent'
                                }`}
                        >
                            <div
                                className="flex-shrink-0 overflow-hidden"
                                style={{
                                    width: '44px',
                                    height: '44px',
                                    borderRadius: '50%',
                                    backgroundColor: '#f3f4f6'
                                }}
                            >
                                {getStockIcon(stock.symbol)}
                            </div>

                            <div className="flex-1 text-left min-w-0">
                                <div className="font-semibold text-gray-900 text-base">
                                    {/* {stock.symbol} */}
                                    <Typography variant="body1" gutterBottom>
                                        {stock.symbol}
                                    </Typography>
                                </div>
                                <div className="text-sm text-gray-500 truncate mt-0.5">
                                    {/* {stock.description || stock.name} */}
                                    <Typography variant="body1" gutterBottom>
                                        {stock.description || stock.name}
                                    </Typography>
                                </div>
                            </div>

                            <div className="flex items-center gap-2 flex-shrink-0">
                                <span className="text-sm font-medium text-gray-600">
                                    {stock.exchange}
                                    <Typography variant="body1" gutterBottom>
                                        {stock.exchange}
                                    </Typography>
                                </span>
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default SearchSuggestions;